export class ActualizarDatosRequest {
    birthDate :  string  ;
    document :  string  ;
    email :  string  ;
    id :  string  ;
    name :  string  ;
    passwordNew :  string  ;
    passwordOld :  string  ;
    photo :  string  ;
    provider :  string  ;
    surname :  string  ;
    telephone :  string  ;
    typeDocument :  string;
    /* daet1 ini */
    department :  string;
    province:  string;
    district:  string;
    postalcode:  string;
    /* daet1 fin */
    acceptAdditionalDataTreatment: string;
    constructor(){
       this.birthDate = ""  ;
       this.document =  ""  ;
       this.email =  ""  ;
       this.id =  ""  ;
       this.name =  ""  ;
       this.passwordNew =  ""  ;
       this.passwordOld =  ""  ;
       this.photo =  ""  ;
       this.provider = ""  ;
       this.surname =  ""  ;
       this.telephone = "" ;
       this.typeDocument =  "" ;
       /* daet1 ini */
       this.department =  "" ;
       this.province =  "" ;
       this.district =  "" ;
       this.postalcode =  "" ;
       /* daet1 fin */
       this.acceptAdditionalDataTreatment = "0";
    }

}
